import { render, staticRenderFns } from "./PopupDeleteBox.vue?vue&type=template&id=20e8a668&scoped=true&"
import script from "./PopupDeleteBox.vue?vue&type=script&lang=js&"
export * from "./PopupDeleteBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupDeleteBox.vue?vue&type=style&index=0&id=20e8a668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e8a668",
  null
  
)

export default component.exports